import React from 'react';

/**
 * Поддерживает ли браузер scroll anchoring: сам удерживает видимое, когда выше
 * экрана меняется высота (нет в iOS Safari до 27)
 *
 * @returns {boolean}
 */
export const checkIfScrollAnchoringSupported = () => (
  typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('overflow-anchor', 'auto')
);

/**
 * Полоса над списком игроков мобильного лобби: место под арт своей фракции и
 * плашка отсчета (см. .lobby-countdown-slot). Ее высоту меняют появление арта
 * (isWithArt) и содержимое (contentHeight).
 *
 * Без scroll anchoring полоса, выросшая или сжавшаяся выше экрана, двигала бы
 * все, что под ней: выбрал фракцию из карточки, прокрутив к своей плашке, —
 * плашка и кнопки уезжают на 200–280 px, а причины не видно. Тогда полоса
 * меняется сразу, без перехода, и прокрутка сдвигается на ту же величину. На
 * экране полоса меняется плавно, как обычно; браузер со scroll anchoring
 * сдвиг гасит сам.
 *
 * Прежние высоту и прокрутку снимаем до изменения DOM (getSnapshotBeforeUpdate
 * есть только у класса): после него их уже не узнать — без перехода
 * (prefers-reduced-motion) высота сразу новая, а у низа страницы браузер сам
 * прижимает прокрутку к новой длине.
 */
class LobbyCountdownSlot extends React.Component {
  slotRef = React.createRef();

  getSnapshotBeforeUpdate(prevProps) {
    const {isWithArt, contentHeight} = this.props;
    const slot = this.slotRef.current;
    const isHeightChanging = prevProps.isWithArt !== isWithArt || prevProps.contentHeight !== contentHeight;
    if (!slot || !isHeightChanging || checkIfScrollAnchoringSupported()) {
      return null;
    }
    const rect = slot.getBoundingClientRect();
    // Без раскладки (тесты) и полоса хоть краем на экране — меняется плавно
    if (rect.height === 0 || rect.bottom > 0) {
      return null;
    }
    return {height: rect.height, scrollY: window.scrollY};
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const slot = this.slotRef.current;
    if (!snapshot || !slot) {
      return;
    }
    slot.style.transition = 'none';
    const {height} = slot.getBoundingClientRect();
    window.scrollTo(0, snapshot.scrollY + height - snapshot.height);
    // Переход возвращаем, когда новая высота уже применена, — иначе он
    // доиграл бы прежний
    slot.getBoundingClientRect();
    slot.style.transition = '';
  }

  render() {
    const {className, style, children} = this.props;
    return (
      <div ref={this.slotRef} className={className} style={style}>
        {children}
      </div>
    );
  }
}

export default LobbyCountdownSlot;
